import { FC, useEffect } from 'react'

import { getNavigationIcon } from '@/constants/navigationAssets'

import { CheckboxProps } from './Checkbox.types'
import {
  CheckboxContainer,
  CheckboxElement,
  CheckboxText
} from './Checkbox.styled'
import { useCheckbox } from './useCheckbox'

const Checkbox: FC<CheckboxProps> = ({
  isSelected: initialSelected,
  text,
  onChange,
  value
}) => {
  const { isSelected, toggleCheckbox, setIsSelected } = useCheckbox(
    initialSelected,
    () => onChange(value)
  )
  useEffect(() => {
    setIsSelected(initialSelected)
  }, [initialSelected])

  return (
    <CheckboxContainer onClick={toggleCheckbox}>
      <CheckboxElement isSelected={isSelected}>
        {isSelected && (
          <img
            src={getNavigationIcon('selectedWhite')}
            alt="Selected"
            loading="lazy"
          />
        )}
      </CheckboxElement>
      <CheckboxText>{text}</CheckboxText>
    </CheckboxContainer>
  )
}

export default Checkbox
